import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const useStyles = makeStyles()((theme) => ({
  listButtonStyle: {
    cursor: "default !important",
    paddingLeft: 0,
    paddingRight: "5px",
    borderBottom: "0.5px solid #EAE9E9",
    "&: hover": {
      backgroundColor: "transparent",
    },
  },
  listButtonStylePending: {
    cursor: "default !important",
    paddingLeft: 0,
    paddingRight: "5px",
    borderBottom: "0.5px solid #EAE9E9",
    "&: hover": {
      backgroundColor: "transparent",
    },
  },
  pageGrid: {
    display: "grid",
    gridTemplateColumns: "20% 60% 20%",
    alignItems: "center",
    // height: "7vh",
    paddingBottom: "1vh",
  },
  viewBadge: {
    width: "100%",
    "& .MuiBadge-badge": {
      transform: "rotate(-47deg)",
      top: "38px",
      left: "-6px",

      fontSize: "10px",
      padding: "4px 8px",
      backgroundColor: "#4d1277",
      color: "white",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      border: "1px solid white",
      zIndex: 1,
      height: "12px",
      width: "56px",
    },
  },
  buttonStyle: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "12px",
    color: "#4D1277",
    padding: "3px 5px",
    transition: "all 0.3s ease",
    textTransform: "capitalize",
    // "&:hover": {
    //   borderRadius: "4px",
    //   backgroundColor: "#4D127733",
    //   cursor: "pointer",
    // },
  },
  buttonStyleHover: {
    borderRadius: "4px",
    backgroundColor: "#4D127733",
    cursor: "pointer",
  },
  viewingStats: {
    borderRadius: "4px",
    backgroundColor: "#4D127733",
  },
  pageContainer: {
    // overflowY: "auto",
    height: "100%",
    width: "100%",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  pageRow: {
    padding: "10px 0",
  },
  pageText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "10%",
    marginBottom: "10px",
  },
  AgentListItem: {
    marginBottom: "10px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  listItemText: {
    color: theme.palette.primary.main,
    fontSize: 12,
    fontWeight: 400,
  },
  profile: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    marginRight: 10,
    fontSize: "12px",
    fontWeight: 500,
  },
  name: {
    fontWeight: 400,
    fontSize: "12px",
    fontFamily: "Poppins",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  avatarAndText: {
    display: "flex",
    alignItems: "center",
  },
  figure: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: "#272525",
    paddingTop: 5,
  },
  primary: {
    color: "black !important",
    fontSize: "16px !important",
    fontWeight: 400,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "70%",
    display: "block", // Ensure ellipsis works
  },
}));

export default useStyles;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
});
export { StyledTooltip };
